import tabNames from '@enums/tab-names';
import commonGuardMap from '@/js/pages/common-guard-map';

const guardsMap = {
    ...commonGuardMap(tabNames.preparation),
};

export default guardsMap;
